import { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Button, Dialog, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import { useCartStore } from '../../../stores/cartStore';

const RedeemDialog = (props) => {
  const cart = useCartStore((state) => state.cart);
  const setCart = useCartStore((state) => state.setCart);

  const [count, setCount] = useState(1);

  const limit = props.reward?.limit > 0 ? props.reward.limit : undefined;

  useEffect(() => {
    if (props.open) {
      const existing = cart.find((item) => item.reward_id === props.reward?._id);
      setCount(existing?.quantity || 1);
    }
  }, [props.open, props.reward?._id, cart]);

  const onCountChange = (e) => {
    const value = e.target.value;
    if (!value) {
      setCount('');
    } else if (value === '0') {
      setCount(1);
    } else {
      setCount(limit ? Math.min(+value, limit) : +value);
    }
  };

  const decreaseQty = () => {
    setCount((prev) => {
      if (+prev === 1) {
        return prev;
      } else {
        return +prev - 1;
      }
    });
  };

  const increaseQty = () => {
    setCount((prev) => {
      if (limit && +prev >= limit) return prev;
      return +prev + 1;
    });
  };

  const addToCart = () => {
    const targetItem = {
      image: props.reward.image[0],
      reward_id: props.reward._id,
      quantity: count,
    };

    if (count > 0) {
      const clone = [...cart];
      let index = _.findIndex(clone, { reward_id: targetItem.reward_id });

      if (index !== -1) {
        clone.splice(index, 1, targetItem);
        setCart([...clone]);
      } else {
        setCart([...clone, targetItem]);
      }
    }

    props.onClose();
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
      <Box sx={{ padding: '20px 16px' }}>
        <Typography
          id="title"
          sx={{
            fontSize: '1.5rem',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '5px',
            color: '#005972',
          }}
        >
          แลกของรางวัล
        </Typography>

        <Typography
          id="reward_name"
          sx={{
            fontSize: '2rem',
            fontWeight: '500',
            lineHeight: '1.75rem',
            textAlign: 'center',
            marginBottom: '10px',
            color: '#005972',
          }}
        >
          {props.reward?.name}
        </Typography>

        <Box
          id="point"
          sx={{
            fontSize: '1.45rem',
            lineHeight: '1rem',
            fontWeight: '500',
            color: '#005972',
            textAlign: 'center',
            marginBottom: '25px',
          }}
        >
          คะแนนที่ใช้{' '}
          <Box component="span" sx={{ color: '#004B61' }}>
            {+props?.reward?.point * count}
          </Box>{' '}
          คะแนน
        </Box>

        <Box
          id="change_quantity"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '.5rem',
            maxWidth: '350px',
            margin: '0 auto 20px',
          }}
        >
          <ChangeQtyButton onClick={decreaseQty} disabled={count <= 1}>
            <RemoveIcon />
          </ChangeQtyButton>
          <Box sx={{ width: 'calc(100% - 80px)' }}>
            <TextField
              fullWidth
              placeholder="ระบุจำนวน"
              type="text"
              value={count}
              onChange={onCountChange}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                autoComplete: 'off',
                readOnly: true,
                style: { textAlign: 'center' },
              }}
              sx={{
                border: '2px solid #005972',
                borderRadius: '8px',

                '& .MuiInputBase-root': {
                  fontSize: '1.5rem',
                  borderRadius: '8px',
                },

                '& .MuiInputBase-input': {
                  fontSize: '1.5rem',
                  padding: '5px 10px',
                  height: '30px',
                },

                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
              }}
            />
          </Box>
          <ChangeQtyButton onClick={increaseQty} disabled={limit && count >= limit}>
            <AddIcon />
          </ChangeQtyButton>
        </Box>

        <Box
          sx={{
            paddingTop: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Button
            fullWidth
            onClick={props.onClose}
            sx={{
              width: '100px',
              height: '40px',
              fontSize: '1.25rem',
              color: '#014B60',
              backgroundColor: '#F5F5F5',
              borderRadius: '8px',

              '&:hover': {
                color: '#014B60',
                backgroundColor: '#F5F5F5',
                opacity: '.85',
              },
            }}
          >
            ปิด
          </Button>
          <Button
            fullWidth
            onClick={addToCart}
            sx={{
              width: 'fit-content',
              height: '40px',
              padding: '0 20px',
              fontSize: '1.25rem',
              color: 'white',
              backgroundColor: '#E1000C',
              borderRadius: '8px',

              '&:hover': {
                color: 'white',
                backgroundColor: '#E1000C',
                opacity: '.85',
              },
            }}
          >
            เพิ่มสินค้าลงตะกร้า
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

const ChangeQtyButton = ({ onClick, children, disabled }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: 30,
        minWidth: 'unset',
        height: 30,
        minHeight: 'unset',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        color: 'white',
        backgroundColor: '#FF0000',
        fontSize: '1rem',
        padding: 0,

        '&:hover': {
          backgroundColor: '#FF0000',
        },

        '&.Mui-disabled': {
          backgroundColor: '#fafafa',
        },
      }}
    >
      {children}
    </Button>
  );
};

export default RedeemDialog;
